<template>
  <div>
    <TenantConfirm />
    <ECircularContact
      ref="eCircularContact"
      :companyId="companyId"
      :tenancyId="tenancyId"
      :allowLinkContacts="allowLinkContacts"
      :linkFunc="linkFunc"
    />
    <EmergencyContact
      ref="emergencyContact"
      :companyId="companyId"
      :tenancyId="tenancyId"
      :allowLinkContacts="allowLinkContacts"
      :linkFunc="linkFunc"
    />
    <FireMarshalContact
      ref="fireMarshalContact"
      :allowLinkContacts="allowLinkContacts"
      :linkFunc="linkFunc"
    />
    <MarketingContact
      v-if="isRetail"
      ref="marketingContact"
      :tenancyId="tenancyId"
      :allowLinkContacts="allowLinkContacts"
      :linkFunc="linkFunc"
    />
    <OthersContact
      :companyId="companyId"
      :tenancyId="tenancyId"
      :allowLinkContacts="allowLinkContacts"
      :linkFunc="linkFunc"
    />
  </div>
</template>

<script>
import TenantConfirm from '@/pages/ccd/TenantConfirm'
import ECircularContact from '@/modules/ccd/tenancy/edit/ECircularContact'
import EmergencyContact from '@/modules/ccd/tenancy/edit/EmergencyContact'
import MarketingContact from '@/modules/ccd/tenancy/edit/MarketingContact'
import OthersContact from '@/modules/ccd/tenancy/edit/OthersContact'
import FireMarshalContact from './FireMarshalContact.vue'

export default {
  name: 'TenancyAllContactsEdit',
  components: {
    TenantConfirm,
    ECircularContact,
    EmergencyContact,
    FireMarshalContact,
    MarketingContact,
    OthersContact,
  },
  props: {
    tenancyId: [String, Number],
    companyId: [String, Number],
    allowLinkContacts: Boolean,
    linkFunc: Function,
    isRetail: Boolean,
  },
  mounted () {
    this.$refs.eCircularContact.removeInvalidFloors()
  },
}
</script>
